const contact = {
    EMAIL: 'etix@softorb.co.id'
}

export default contact